import React from "react";

import {Avatar, Box, Stack, Text} from "@unibuddy/patron";

import avatarFace1 from "./assets/Avatar_faces.png";
import avatarFace2 from "./assets/Avatar_faces-1.png";
import avatarFace3 from "./assets/Avatar_faces-2.png";

const MessageBubble = ({text, avatarPhoto}: {text: string; avatarPhoto?: string}) => (
    <Box display="flex" flexDirection="row">
        <Box marginRight="xxsmall">
            <Avatar src={avatarPhoto} alt="" size="xs" />
        </Box>

        <Box
            bgColor="grey100"
            borderRadius="small"
            padding="small-medium"
            alignItems="flex-start"
            width="fit-content"
            aria-hidden
            style={{whiteSpace: "pre-wrap"}}
        >
            <Text weight="200" size="large">
                {text}
            </Text>
        </Box>
    </Box>
);

export function ChatSection() {
    return (
        <Stack space="small-medium">
            <MessageBubble
                text={"What's the best thing about student \nlife?"}
                avatarPhoto={avatarFace1}
            />
            <Box paddingLeft="medium-large">
                <MessageBubble
                    text={"Is it easy to make friends in your first \nyear?"}
                    avatarPhoto={avatarFace2}
                />
            </Box>
            <MessageBubble text="What’s the workload like?" avatarPhoto={avatarFace3} />
        </Stack>
    );
}
